//single-view-inventory
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FleetService } from '../../../core/services/fleet.service';
import { InventoryService } from '../../../core/services/inventory.service';
import { ReportsService } from '../../../core/services/reports.service';
import { SETTINGS } from '../../../core/config/common.settings';
import * as _ from 'lodash';

@Component({
  selector: 'app-single-view-inventory',
  templateUrl: './single-view-inventory.component.html',
  styleUrls: ['./single-view-inventory.component.scss'],
})
export class SingleViewInventoryComponent implements OnInit {
  @ViewChild('image', { static: false }) image!: ElementRef;
  breadcrumbs: any[] = [];
  fleetId: any;
  inventoryId: any;
  inventoryData: any;
  inventoryType = 'Before';
  singleDamages: any[] = [];
  fleetData = {
    _id: ' ',
    vehicleDetails: {
      vehicleModel: '',
      registrationNumber: '',
    },
    generalInformation: {
      vehicleType: '',
    },
  };
  data = [{ dummy: '' }];
  selectedBooking = {
    type: '',
    refNo: '',
    _id: '',
  };
  function = true;
  loading = false;
  isShowReport = false;
  pdf: any;
  pdfLoader = false;

  // Normal inventory reports handling
  isVisibleGenerateInventoryReport = false;
  bookingData: any;

  constructor(
    private route: ActivatedRoute,
    private fleetService: FleetService,
    private inventoryService: InventoryService,
    private router: Router,
    private reportService: ReportsService,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.fleetId = this.route.snapshot.paramMap.get('fleetId');
    this.inventoryId = this.route.snapshot.paramMap.get('id');
    this.fleetService.getOneFleetById(this.fleetId).then((res) => {
      this.fleetData = res;

      this.inventoryService.getInventoryById(this.inventoryId).then((res) => {
        this.inventoryData = res;
        console.log(res);
        if (!this.inventoryData.after.inspectionDetails) {
          this.inventoryType = 'Before';
          this.singleDamages = this.inventoryData.before.damages;
        } else {
          this.inventoryType = 'After';
          this.singleDamages = this.inventoryData.after.damages;
        }
        if (res?.before.inspectionDetails.bookingDetails?.booking) {
          this.fleetService
            .getAllBookingsByFleet(this.fleetId)
            .subscribe((resp: any) => {
              this.selectedBooking = resp?.find(
                (bo: any) =>
                  bo._id ===
                  res?.before?.inspectionDetails?.bookingDetails?.booking,
              );
              this.bookingData = {
                bookingAgent: 'SR_RENT_A_CAR',
                bookingRefNo: this.selectedBooking?.refNo,
                onlyRecord: true,
              };
              console.log(this.selectedBooking);
            });
        } else {
          this.bookingData = {
            bookingAgent: 'SR_RENT_A_CAR',
            onlyRecord: true,
          };
        }

        this.loading = false;
        this.setBreadcrumbs();
      });
    });
  }

  setBreadcrumbs(): void {
    this.breadcrumbs = [
      {
        title: 'Fleets',
        icon: 'car',
        route: '/admin/fleets',
      },
      {
        title: this.fleetData.vehicleDetails.registrationNumber,
        route: `/admin/fleets/${this.fleetId}`,
      },
      {
        title: ' Inventory ',
        route: [
          `/admin/fleets/${this.fleetId}`,
          { pageName: 'fleetInventory' },
        ],
      },
      {
        title: ` ${this.inventoryData.inventoryId} `,
      },
    ];
  }

  showReportGenerate(): void {
    this.isShowReport = true;
  }

  handleCancel(): void {
    this.isShowReport = false;
  }

  generatePdf(): void {
    this.pdfLoader = false;
    this.reportService.generateInventoryReport(this.fleetId).then((res) => {
      this.pdf = res;
      this.pdfLoader = true;
    });
  }

  emailPdf(): void {
    this.reportService.emailPdf();
    // const email = 'recipient@gmail.com';
    // const subject = 'Your email subject';
    // const body = 'Your email body content';
    //
    // // Create the mailto link
    // // Open the default email client (Gmail, if available)
    // window.location.href = `mailto:${email}?subject=${encodeURIComponent(
    //   subject,
    // )}&body=${encodeURIComponent(body)}`;
  }

  printReport(): void {
    this.reportService.printReport(this.pdf).then(() => {});
  }

  viewPdf(): void {
    this.reportService.viewReport(this.pdf);
  }

  downloadPdf(): void {
    this.reportService.downloadReport(this.pdf);
  }

  goToBooking(): void {
    console.log(this.selectedBooking);

    if (this.selectedBooking.type === 'Transfer') {
      this.router.navigate([
        `admin/booking-transfer/${this.selectedBooking._id}`,
      ]);
    } else if (this.selectedBooking.type === 'Other') {
      this.router.navigate([`admin/booking-other/${this.selectedBooking._id}`]);
    } else {
      this.router.navigate([`/admin/booking-rent/${this.selectedBooking._id}`]);
    }
  }

  // Normal inventory reports handling
  onGetGenerateInventoryReportChange(event: any): void {
    switch (event.name) {
      case 'visible':
        this.isVisibleGenerateInventoryReport = false;
        break;
    }
  }

  showGenerateInventoryReportPopup(): void {
    this.isVisibleGenerateInventoryReport = true;
  }

  afterInspection(data: any): void {
    this.router.navigate([
      `admin/fleets/${this.fleetData._id}/inventory/add-edit`,
      { id: data, status: 'After' },
    ]);
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }

  finalInspection(data: any): void {
    this.router.navigate([
      `admin/fleets/${this.fleetData._id}/inventory/add-edit`,
      { id: data, status: 'Final' },
    ]);
  }

  deleteInventory(data: any): void {
    this.inventoryService.deleteInventory(data).then((res) => {
      this.ngOnInit();
      this.router.navigate([`admin/fleets/${this.fleetData._id}`]);
    });
  }
}
